<form
  class="d-flex flex-column"
  [formGroup]="form"
  *ngIf="!details?.isClaimSubmitted && details?.isRebateDue"
  (ngSubmit)="onSubmit()"
>
  <div class="row">
    <div class="mt-2 mt-lg-0 col-12 col-lg-4" *ngIf="!isNA">
      <label for="invoiceNumber"
        ><strong>{{ 'Rebate claim number' | translate }}</strong></label
      >
      <input type="text" class="form-control" id="invoiceNumber" formControlName="invoiceNumber" />
    </div>

    <div class="mt-2 mt-lg-0 col-12 col-sm-6 col-lg-4">
      <label for="localCurrency"
        ><strong>{{ 'Local currency' | translate }}</strong></label
      >
      <input type="text" class="form-control" id="localCurrency" formControlName="localCurrency" />
    </div>

    <div class="mt-2 mt-lg-0 col-12 col-sm-6 col-lg-4">
      <label for="rebateAmountInLocalCurrency"
        ><strong>{{ 'Rebate amount in local currency' | translate }}</strong></label
      >
      <input
        type="text"
        class="form-control"
        id="rebateAmountInLocalCurrency"
        formControlName="rebateAmountInLocalCurrency"
      />
    </div>
  </div>
  <div class="row mt-2" *ngIf="isLA">
    <div class="mt-2 mt-lg-0 col-12 d-flex align-items-center gap-3">
      <span class="fw-bold me-1">{{ 'Invoice_status' | translate }}</span>

      <label for="hasInvoiceYes" class="d-inline-flex align-items-center gap-2 mb-0 cursor-pointer">
        <input
          type="radio"
          class="form-check-input m-0"
          id="hasInvoiceYes"
          formControlName="hasInvoice"
          [value]="true"
        />
        <span>{{ 'Invoice_status_positive' | translate }}</span>
      </label>

      <label for="hasInvoiceNo" class="d-inline-flex align-items-center gap-2 mb-0 cursor-pointer">
        <input
          type="radio"
          class="form-check-input m-0"
          id="hasInvoiceNo"
          formControlName="hasInvoice"
          [value]="false"
        />
        <span>{{ 'Invoice_status_negative' | translate }}</span>
      </label>
    </div>
  </div>
  <div class="row" *ngIf="form.get('hasInvoice')?.value === false">
    <div class="mt-2 mt-lg-0 col-12 col-sm-6 col-lg-4">
      <label for="taxAmount1"
        ><strong>{{ 'Tax Amount 1' | translate }}</strong></label
      >
      <input type="number" class="form-control" id="taxAmount1" formControlName="taxAmount1" />
    </div>

    <div class="mt-2 mt-lg-0 col-12 col-sm-6 col-lg-4">
      <label for="taxAmount2"
        ><strong>{{ 'Tax Amount 2' | translate }}</strong></label
      >
      <input type="number" class="form-control" id="taxAmount2" formControlName="taxAmount2" />
    </div>
  </div>
  <div class="mt-4 form-group" *ngIf="!isNA && (!form.get('hasInvoice') || form.get('hasInvoice')?.value === true)">
    <label for="invoiceFile" class="m-0 btn btn-primary rebate-file"
      ><div class="h-100 d-flex justify-content-center align-items-center">{{ 'Attach file' | translate }}</div></label
    >
    <input
      type="file"
      class="form-control-file d-none"
      id="invoiceFile"
      formControlName="invoiceFile"
      (change)="onFileSelected($event)"
    />
    <span class="ms-3"> {{ selectedFile?.name || 'No file selected.' | translate }}</span>
  </div>
  <div class="mt-3 form-group">
    <button type="submit" class="btn btn-primary rebate-file">
      {{ (isNA ? 'Submit rebate claim' : 'Upload rebate claim') | translate }}
    </button>
  </div>
</form>
